import getDOMTokenList from './/getDOMTokenList';

export default function getElementClassList(elem) {
  if ('classList' in elem) {
    return elem.classList;
  } else {
    return getDOMTokenList(elem, 'className');
  }
}
